<template>
	<!-- 头部组件 -->
	<div class="tabBar">
		<div class="header">
			<div class="imgFrame">
				<img src="../assets/menu4.png" class="imgStyle" @click="menuClick" />
			</div>
			<div class="fontFrame">
				<span>山哩数智科技有限公司官网</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "/index",
				RouteState: false
			};
		},
		methods: {
			handleSelect(routePath) {
				this.activeIndex = this.$route.path;
			},
			menuClick() {
				console.log("")
			}
		},
		watch: {
			"$route.path": {
				immediate: true,
				handler(routePath) {
					this.handleSelect(routePath);
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.tabBar {
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;

		.header {
			z-index: 999;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			background-color: rgb(132, 0, 0);
			height: 100%;
			width: 100%;
			position: relative;

			.fontFrame {
				color: #fff;
				/* position: absolute; */
				font-weight: bold;
				/* top: 0;
				bottom: 0;
				left: 1%;
				right: 0;
				margin: auto; */
				width: 50%;
				height: 30px;
				/* text-align: center; */
				/* margin-left: 40px; */
				line-height: 30px;
			}

			.imgFrame {
				width: 1.5rem;
				margin: 0 2rem;

				&:hover {
					cursor: pointer;
					transform: scale(1.2);
				}
			}
		}

		.content {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.imgStyle {
			height: 100%;
			width: 100%;
		}
	}

	.el-menu {
		display: flex;
	}

	.el-menu-item {
		padding: 0 1.4rem;
		border: none;
	}

	.el-menu--horizontal>.el-menu-item {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.el-menu.el-menu--horizontal {
		display: flex;
		justify-content: space-between;
		border: none;
		width: 100%;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		color: #fff;
		background-color: rgb(132, 0, 0);
		border-bottom: 3px solid red;
	}
</style>


// WEBPACK FOOTER //
// src/assembly/tabBarNew.vue